import { Link } from 'react-router-dom';
import { Button } from '@/components/ui/button';
import { cn } from '@/lib/utils';

export interface ProductInlineErrorProps {
  readonly title: string;
  readonly retryLabel: string;
  readonly backLabel: string;
  readonly onRetry: () => void;
  readonly testIdPrefix?: string;
}

export function ProductInlineError({
  title,
  retryLabel,
  backLabel,
  onRetry,
  testIdPrefix = 'product',
}: ProductInlineErrorProps) {
  return (
    <div className="flex min-h-[60vh] items-center justify-center">
      <div
        className={cn(
          'bg-sand-100 dark:bg-sand-800 rounded-card shadow-card w-full max-w-md p-10 text-center',
        )}
        data-testid={`${testIdPrefix}-error`}
      >
        <h2 className="font-display text-terracotta mb-2 text-xl font-semibold">{title}</h2>
        <div className="mt-4 flex items-center justify-center gap-2">
          <Button type="button" onClick={onRetry} data-testid={`${testIdPrefix}-retry`}>
            {retryLabel}
          </Button>
          <Button asChild variant="outline">
            <Link to="/products">{backLabel}</Link>
          </Button>
        </div>
      </div>
    </div>
  );
}
